"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDateFromInput = makeDateFromInput;
exports.getYearOptions = getYearOptions;
exports.getYearMonthOptions = getYearMonthOptions;
exports.getPayrollPeriodOptions = getPayrollPeriodOptions;
exports.getMonthsRange = getMonthsRange;
exports.invoicedYearMonthOptions = exports.formatTimestamp = exports.formatPayslipTime = exports.formatPayrollDateLabel = exports.formatPayrollPeriodDate = exports.friendlyYearMonth = exports.formatYearMonth = exports.formatFullDate = exports.formatYearMonthDay = exports.formatDayMonth = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dateFns = require("date-fns");

var _dateFnsTz = require("date-fns-tz");

var _dates = require("../constants/dates");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var emptyDate = '—';
var monthYearFormats = ['yyyy-MM', 'MMMM yyyy', 'MMMM y', 'LLLL yyyy'];

function isValidMonthNumber(monthNumber) {
  return monthNumber >= 1 && monthNumber <= 12;
}

function makeDateFromInput(datetime) {
  try {
    if (!datetime || datetime === 'no' || /^\d{4}$/.test(datetime)) {
      return null;
    } // Date contstructor parses yyyy-mm and yyyy-m dates differently, so
    // we normalize it here.
    // dddd-m → dddd-mm conversion


    if (/^\d{4}-\d{1}$/.test(datetime)) {
      var _datetime$split = datetime.split('-'),
          _datetime$split2 = (0, _slicedToArray2["default"])(_datetime$split, 2),
          year = _datetime$split2[0],
          month = _datetime$split2[1];

      datetime = "".concat(year, "-0").concat(month);
    } // we assume that all string dates are coming from backend, where we store them in UTC


    var timeZone = typeof datetime === 'string' && 'utc';
    var date = new Date(datetime);
    return timeZone ? (0, _dateFnsTz.utcToZonedTime)(date, timeZone) : date;
  } catch (e) {
    return null;
  }
}

function makeFormatFn(dateFormat) {
  return function (datetime) {
    // yyyy-mm format is only allowed for yyyy-MM output,
    // otherwise we will have to assume date
    if (/^\d{4}-\d{1,2}$/.test(datetime)) {
      if (monthYearFormats.includes(dateFormat)) {
        var _datetime$split3 = datetime.split('-'),
            _datetime$split4 = (0, _slicedToArray2["default"])(_datetime$split3, 2),
            year = _datetime$split4[0],
            month = _datetime$split4[1];

        if (!year || !month || !isValidMonthNumber(parseInt(month, 10))) {
          return emptyDate;
        }
      } else {
        return emptyDate;
      }
    }

    var date = makeDateFromInput(datetime);

    if (!date) {
      return emptyDate;
    }

    return (0, _dateFnsTz.format)(date, dateFormat);
  };
}

var formatDayMonth = makeFormatFn('do MMM');
exports.formatDayMonth = formatDayMonth;
var formatYearMonthDay = makeFormatFn('yyyy-MM-dd');
exports.formatYearMonthDay = formatYearMonthDay;
var formatFullDate = makeFormatFn('do MMM y');
exports.formatFullDate = formatFullDate;
var formatYearMonth = makeFormatFn('yyyy-MM');
exports.formatYearMonth = formatYearMonth;
var friendlyYearMonth = makeFormatFn('LLLL yyyy');
exports.friendlyYearMonth = friendlyYearMonth;
var formatPayrollPeriodDate = makeFormatFn('MMMM yyyy');
exports.formatPayrollPeriodDate = formatPayrollPeriodDate;
var formatPayrollDateLabel = makeFormatFn('LLLL do, u');
exports.formatPayrollDateLabel = formatPayrollDateLabel;
var formatPayslipTime = makeFormatFn('MMMM y');
exports.formatPayslipTime = formatPayslipTime;
var formatTimestamp = makeFormatFn('p, PPP');
exports.formatTimestamp = formatTimestamp;

function getYearOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$startingYear = _ref.startingYear,
      startingYear = _ref$startingYear === void 0 ? _dates.EMPLOY_START_DATE : _ref$startingYear,
      _ref$includeBlankOpti = _ref.includeBlankOption,
      includeBlankOption = _ref$includeBlankOpti === void 0 ? true : _ref$includeBlankOpti,
      _ref$includeMonths = _ref.includeMonths,
      includeMonths = _ref$includeMonths === void 0 ? false : _ref$includeMonths,
      _ref$extraYears = _ref.extraYears,
      extraYears = _ref$extraYears === void 0 ? 1 : _ref$extraYears;

  var year = new Date().getUTCFullYear() + extraYears;
  var result = includeBlankOption ? [{
    label: 'All',
    value: ''
  }] : [];

  while (year >= startingYear) {
    if (includeMonths) {
      for (var i = 0; i < _dates.monthOptions.length; i++) {
        result.push({
          label: "".concat(_dates.monthOptions[i].label, " ").concat(year),
          // "- 1" because Date() uses 0 index months
          value: formatYearMonth(new Date(year, _dates.monthOptions[i].value - 1, 1))
        });
      }
    } else {
      result.push({
        label: year,
        value: year
      });
    }

    year -= 1;
  }

  return result;
}

var defaultConfig = {
  formatValue: formatYearMonth,
  formatLabel: friendlyYearMonth,
  extraMonths: 4,
  start: new Date(_dates.EMPLOY_START_DATE, 0, 1)
};

function getYearMonthOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultConfig$config = _objectSpread(_objectSpread({}, defaultConfig), config),
      formatValue = _defaultConfig$config.formatValue,
      formatLabel = _defaultConfig$config.formatLabel,
      extraMonths = _defaultConfig$config.extraMonths,
      start = _defaultConfig$config.start;

  return (0, _dateFns.eachMonthOfInterval)({
    start: start,
    end: (0, _dateFns.add)(new Date(), {
      months: extraMonths
    })
  }).map(function (date) {
    return {
      label: formatLabel(date),
      value: formatValue(date)
    };
  }).reverse();
}
/**
 * @deprecated This is a temporary helper needed while
 * backend doesn't support start/end date for payroll periods.
 *
 * In the future, 11th of the month won't have any meaning,
 * as we will support bi-monthly and off-cycle payroll runs,
 * so the list would contain different values.
 */


function getPayrollPeriodOptions() {
  return (0, _dateFns.eachMonthOfInterval)({
    start: new Date(_dates.EMPLOY_START_DATE, 0, 1),
    end: (0, _dateFns.add)(new Date(), {
      months: 12
    })
  }).map(function (date) {
    date.setDate(11);
    return date;
  }).map(function (date) {
    return {
      label: friendlyYearMonth(date),
      value: formatYearMonthDay(date)
    };
  });
}

var invoicedYearMonthOptions = [{
  label: 'Not invoiced yet',
  value: ''
}].concat((0, _toConsumableArray2["default"])(getYearMonthOptions()));
exports.invoicedYearMonthOptions = invoicedYearMonthOptions;

function getMonthsRange(config) {
  var dates = [];
  var dateCounter = makeDateFromInput(config.startDate);
  var endDate = makeDateFromInput(config.endDate);
  dateCounter.setUTCDate(1);
  endDate.setUTCDate(1);

  while (dateCounter < endDate) {
    dates.push(formatYearMonth((0, _dateFnsTz.utcToZonedTime)(dateCounter)));
    dateCounter.setUTCMonth(dateCounter.getUTCMonth() + 1);
  }

  return dates;
}